import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Lenis from "lenis";
import { motion } from "framer-motion";
import BrandPanel from "../components/BrandPanel";
import AuthCard from "../components/AuthCard";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";

const EASE = [0.16, 1, 0.3, 1];

export default function LoginPage() {
  const { user } = useAuth();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <div data-testid="login-page" className="min-h-screen bg-[#050814] text-white grid lg:grid-cols-2 relative">
      <div className="noise-overlay" />
      <BrandPanel />

      {/* Mobile brand strip */}
      <div className="lg:hidden relative overflow-hidden border-b border-white/10 px-6 pt-10 pb-8">
        <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[#5E2BFF]/30 blur-[100px]" />
        <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-[#0066FF]/30 blur-[100px]" />
        <div className="relative z-10">
          <Logo />
          <h1 className="font-display font-medium text-3xl leading-[1.1] tracking-[-0.02em] text-white mt-8">
            <span className="block overflow-hidden">
              <motion.span
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
                className="block"
              >
                Care, aligned
              </motion.span>
            </span>
            <span className="block overflow-hidden">
              <motion.span
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, ease: EASE, delay: 0.35 }}
                className="block text-gradient-brand pb-1"
              >
                by intelligence.
              </motion.span>
            </span>
          </h1>
        </div>
      </div>

      {/* Auth column */}
      <div className="relative flex items-center justify-center px-5 sm:px-10 py-14 lg:py-10 overflow-hidden auth-scroll">
        <div className="absolute top-1/4 -left-32 w-80 h-80 rounded-full bg-[#0066FF]/20 blur-[120px] pointer-events-none" />
        <div className="absolute bottom-0 -right-24 w-80 h-80 rounded-full bg-[#5E2BFF]/20 blur-[120px] pointer-events-none" />
        <AuthCard />
      </div>
    </div>
  );
}
